import { memo } from "react";

import { Navigate, Outlet, useLocation } from "react-router-dom";

import { ROUTES } from "@/constants";
import { useAppSelector } from "@/store/hooks";
import { hasEventSession } from "@/lib/auth/session";
import PageLoader from "@/components/common/PageLoader";

/**
 * Wraps public/auth routes. Redirects already-authenticated users
 * to their original destination (or dashboard) so they never see login again.
 */
const GuestGuard = memo(function GuestGuard() {
  const isAuthenticated = useAppSelector((s) => s.user.isAuthenticated);
  const isRestoringSession = useAppSelector((s) => s.user.isRestoringSession);
  const location = useLocation();

  // If user came from a protected route (state.from), go back there
  const from =
    (location.state as { from?: Location } | null)?.from?.pathname ??
    ROUTES.DASHBOARD;

  if (isRestoringSession) return <PageLoader />;

  if (isAuthenticated && hasEventSession()) {
    return <Navigate to={from} replace />;
  }

  return <Outlet />;
});

export default GuestGuard;
